export interface ComicChapter {
  id: string;
  number: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  tags: string[];
  description: string;
  status: 'completed' | 'ongoing';
  updateDate: string;
  rating: number;
  views: number;
  chapters: ComicChapter[];
}

export interface Category {
  slug: string;
  name: string;
  description: string;
}

export const categories: Category[] = [
  { slug: 'romance', name: '恋爱', description: '甜蜜浪漫的韩国恋爱漫画，讲述心动爱情故事' },
  { slug: 'fantasy', name: '奇幻', description: '穿越异世界、魔法冒险等奇幻题材韩漫' },
  { slug: 'action', name: '热血', description: '战斗、冒险、成长类热血韩国漫画' },
  { slug: 'drama', name: '剧情', description: '深度剧情、人生百态的韩国漫画作品' },
  { slug: 'comedy', name: '喜剧', description: '轻松搞笑的韩国喜剧漫画，欢乐不断' },
  { slug: 'thriller', name: '悬疑', description: '紧张刺激的悬疑推理类韩国漫画' },
  { slug: 'daily', name: '日常', description: '温馨治愈的日常生活类韩国漫画' },
  { slug: 'bl', name: '耽美', description: '精致画风的耽美类韩国漫画作品' },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'she-is-young',
    title: '她如此年轻',
    author: '金智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20cover%20illustration%2C%20young%20beautiful%20woman%20with%20soft%20pastel%20colors%2C%20delicate%20facial%20features%2C%20elegant%20floral%20background%2C%20webtoon%20art%20style%2C%20clean%20lines%2C%20soft%20lighting%2C%20Korean%20digital%20art&width=600&height=800&seq=manhwa-cover-01&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '校园', '甜宠'],
    description: '一段跨越年龄的纯爱故事。当年轻的女主角遇见了成熟稳重的他，命运的齿轮开始转动。在校园与职场之间，两颗心逐渐靠近，谱写出一段令人心动的浪漫恋曲。画风精致细腻，情感描写真实动人。',
    status: 'ongoing',
    updateDate: '2026-08-05',
    rating: 4.8,
    views: 1250000,
    chapters: [
      { id: 'c1-1', number: 1, title: '命运的相遇', updateDate: '2026-01-15' },
      { id: 'c1-2', number: 2, title: '心跳加速', updateDate: '2026-01-22' },
      { id: 'c1-3', number: 3, title: '意外的告白', updateDate: '2026-02-01' },
      { id: 'c1-4', number: 4, title: '甜蜜的开始', updateDate: '2026-02-10' },
      { id: 'c1-5', number: 5, title: '波折与考验', updateDate: '2026-03-01' },
      { id: 'c1-6', number: 6, title: '真心的证明', updateDate: '2026-04-15' },
      { id: 'c1-7', number: 7, title: '幸福的延续', updateDate: '2026-06-20' },
    ],
  },
  {
    id: '2',
    slug: 'sword-of-destiny',
    title: '命运之剑',
    author: '朴俊秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20action%20cover%2C%20warrior%20holding%20a%20glowing%20sword%2C%20epic%20adventure%20theme%2C%20dramatic%20lighting%2C%20dark%20fantasy%20atmosphere%2C%20webtoon%20art%20style%2C%20dynamic%20composition%2C%20Korean%20digital%20illustration&width=600&height=800&seq=manhwa-cover-02&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '战斗'],
    description: '在剑与魔法的世界里，一个普通少年意外获得了传说中的命运之剑。从此踏上了一条充满挑战与奇遇的冒险之旅。强大的敌人、忠诚的伙伴、隐藏的秘密，一切都在等待着他去探索。',
    status: 'ongoing',
    updateDate: '2026-08-04',
    rating: 4.9,
    views: 2300000,
    chapters: [
      { id: 'c2-1', number: 1, title: '觉醒之日', updateDate: '2025-09-01' },
      { id: 'c2-2', number: 2, title: '初入异界', updateDate: '2025-09-15' },
      { id: 'c2-3', number: 3, title: '试炼之路', updateDate: '2025-10-01' },
      { id: 'c2-4', number: 4, title: '命运对决', updateDate: '2025-11-01' },
      { id: 'c2-5', number: 5, title: '新的征程', updateDate: '2026-01-15' },
      { id: 'c2-6', number: 6, title: '暗影来袭', updateDate: '2026-04-01' },
      { id: 'c2-7', number: 7, title: '光明之力', updateDate: '2026-06-15' },
      { id: 'c2-8', number: 8, title: '终极之战', updateDate: '2026-07-20' },
    ],
  },
  {
    id: '3',
    slug: 'secretary-kim',
    title: '金秘书为何那样',
    author: '李恩珠',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20cover%2C%20stylish%20professional%20woman%20in%20modern%20office%20setting%2C%20chic%20fashion%2C%20warm%20color%20palette%2C%20webtoon%20art%20style%2C%20clean%20elegant%20design%2C%20soft%20ambient%20lighting%2C%20Korean%20digital%20art&width=600&height=800&seq=manhwa-cover-03&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '职场', '喜剧'],
    description: '完美主义副会长和他那能力超群的金秘书之间的浪漫办公室故事。当金秘书突然提出辞职，副会长才意识到她在他生命中的重要性。一场啼笑皆非的追妻之旅就此展开。',
    status: 'completed',
    updateDate: '2026-07-20',
    rating: 4.7,
    views: 3800000,
    chapters: [
      { id: 'c3-1', number: 1, title: '完美的秘书', updateDate: '2025-03-01' },
      { id: 'c3-2', number: 2, title: '辞职信', updateDate: '2025-03-15' },
      { id: 'c3-3', number: 3, title: '副会长慌了', updateDate: '2025-04-01' },
      { id: 'c3-4', number: 4, title: '真心话', updateDate: '2025-05-01' },
      { id: 'c3-5', number: 5, title: '大结局', updateDate: '2025-07-01' },
    ],
  },
  {
    id: '4',
    slug: 'shadow-hunter',
    title: '暗影猎手',
    author: '崔宇振',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20thriller%20cover%2C%20mysterious%20hunter%20in%20dark%20urban%20setting%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20intense%20mood%2C%20webtoon%20art%20style%2C%20cool%20tone%20color%20palette%2C%20Korean%20digital%20illustration&width=600&height=800&seq=manhwa-cover-04&orientation=portrait',
    category: 'action',
    tags: ['热血', '战斗', '超能力'],
    description: '在首尔的阴影中，隐藏着一群拥有特殊能力的猎手。主角觉醒暗影之力后，加入秘密组织对抗黑暗势力。拳拳到肉的战斗场面，扣人心弦的剧情发展，让你欲罢不能。',
    status: 'ongoing',
    updateDate: '2026-08-03',
    rating: 4.6,
    views: 1800000,
    chapters: [
      { id: 'c4-1', number: 1, title: '暗影觉醒', updateDate: '2025-11-01' },
      { id: 'c4-2', number: 2, title: '猎人组织', updateDate: '2025-12-01' },
      { id: 'c4-3', number: 3, title: '首次任务', updateDate: '2026-01-15' },
      { id: 'c4-4', number: 4, title: '危机四伏', updateDate: '2026-03-01' },
      { id: 'c4-5', number: 5, title: '真相浮现', updateDate: '2026-05-15' },
      { id: 'c4-6', number: 6, title: '最终对决', updateDate: '2026-07-01' },
    ],
  },
  {
    id: '5',
    slug: 'daily-sunshine',
    title: '日常小确幸',
    author: '韩秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20cute%20casual%20everyday%20scene%20in%20cozy%20cafe%2C%20warm%20sunlight%2C%20pastel%20colors%2C%20gentle%20atmosphere%2C%20webtoon%20art%20style%2C%20soft%20illustration%2C%20Korean%20digital%20art&width=600&height=800&seq=manhwa-cover-05&orientation=portrait',
    category: 'daily',
    tags: ['日常', '治愈', '温馨'],
    description: '一部描绘平凡日常中美好瞬间的治愈系漫画。跟随女主角的脚步，在咖啡馆、书店、公园中寻找生活的小确幸。温暖的画风，细腻的情感，让你在忙碌的生活中找到片刻宁静。',
    status: 'ongoing',
    updateDate: '2026-08-01',
    rating: 4.5,
    views: 890000,
    chapters: [
      { id: 'c5-1', number: 1, title: '咖啡店的一天', updateDate: '2026-01-01' },
      { id: 'c5-2', number: 2, title: '雨天的书店', updateDate: '2026-02-01' },
      { id: 'c5-3', number: 3, title: '公园漫步', updateDate: '2026-03-15' },
      { id: 'c5-4', number: 4, title: '新朋友', updateDate: '2026-05-01' },
      { id: 'c5-5', number: 5, title: '夏日回忆', updateDate: '2026-07-01' },
    ],
  },
  {
    id: '6',
    slug: 'mystery-garden',
    title: '神秘花园',
    author: '张美兰',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20suspense%20cover%2C%20beautiful%20garden%20with%20hidden%20secrets%2C%20mysterious%20atmosphere%2C%20moonlit%20scene%2C%20dark%20floral%20motifs%2C%20webtoon%20art%20style%2C%20eerie%20yet%20elegant%2C%20Korean%20digital%20illustration&width=600&height=800&seq=manhwa-cover-06&orientation=portrait',
    category: 'thriller',
    tags: ['悬疑', '推理', '反转'],
    description: '搬进古老宅邸的女主发现后花园中隐藏着一个惊人的秘密。每当月圆之夜，花园中就会出现一条通往未知世界的路。跟随线索揭开真相的过程中，危险也在一步步逼近。',
    status: 'ongoing',
    updateDate: '2026-08-02',
    rating: 4.7,
    views: 1560000,
    chapters: [
      { id: 'c6-1', number: 1, title: '新居', updateDate: '2026-02-01' },
      { id: 'c6-2', number: 2, title: '花园之谜', updateDate: '2026-03-01' },
      { id: 'c6-3', number: 3, title: '月圆之夜', updateDate: '2026-04-10' },
      { id: 'c6-4', number: 4, title: '消失的邻居', updateDate: '2026-05-20' },
      { id: 'c6-5', number: 5, title: '逼近真相', updateDate: '2026-07-05' },
    ],
  },
  {
    id: '7',
    slug: 'laugh-out-loud',
    title: '笑到肚子痛',
    author: '吴在熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%2C%20funny%20expressive%20characters%20in%20hilarious%20situation%2C%20bright%20vibrant%20colors%2C%20cartoonish%20exaggerated%20style%2C%20webtoon%20art%2C%20energetic%20composition%2C%20Korean%20digital%20illustration&width=600&height=800&seq=manhwa-cover-07&orientation=portrait',
    category: 'comedy',
    tags: ['喜剧', '搞笑', '校园'],
    description: '一群奇葩高中生的爆笑日常！从教室到食堂，从考试到运动会，处处都是笑料。夸张的表情、出人意料的剧情反转，保证让你笑到停不下来。减压神作，不看后悔！',
    status: 'completed',
    updateDate: '2026-06-15',
    rating: 4.4,
    views: 2100000,
    chapters: [
      { id: 'c7-1', number: 1, title: '开学第一天', updateDate: '2025-01-01' },
      { id: 'c7-2', number: 2, title: '食堂大作战', updateDate: '2025-02-01' },
      { id: 'c7-3', number: 3, title: '考试地狱', updateDate: '2025-04-01' },
      { id: 'c7-4', number: 4, title: '运动会', updateDate: '2025-06-15' },
      { id: 'c7-5', number: 5, title: '毕业快乐', updateDate: '2025-09-01' },
    ],
  },
  {
    id: '8',
    slug: 'tears-of-angel',
    title: '天使之泪',
    author: '柳真雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20emotional%20cover%2C%20sad%20beautiful%20woman%20with%20tears%2C%20ethereal%20atmosphere%2C%20soft%20blue%20tones%2C%20melancholic%20mood%2C%20webtoon%20art%20style%2C%20delicate%20illustration%2C%20Korean%20digital%20art&width=600&height=800&seq=manhwa-cover-08&orientation=portrait',
    category: 'drama',
    tags: ['剧情', '虐心', '成长'],
    description: '一个关于失去与重生的感人故事。女主角在经历人生重大变故后，如何从绝望中站起来，重新找到生活的意义。细腻的情感刻画，真实的心理描写，每一话都直击心灵深处。',
    status: 'ongoing',
    updateDate: '2026-08-05',
    rating: 4.9,
    views: 1950000,
    chapters: [
      { id: 'c8-1', number: 1, title: '破碎的世界', updateDate: '2026-01-10' },
      { id: 'c8-2', number: 2, title: '深渊之中', updateDate: '2026-02-15' },
      { id: 'c8-3', number: 3, title: '一丝曙光', updateDate: '2026-03-20' },
      { id: 'c8-4', number: 4, title: '重新出发', updateDate: '2026-05-01' },
      { id: 'c8-5', number: 5, title: '遇见你', updateDate: '2026-06-10' },
      { id: 'c8-6', number: 6, title: '黎明的光芒', updateDate: '2026-07-25' },
    ],
  },
  {
    id: '9',
    slug: 'campus-love',
    title: '恋爱进行时',
    author: '金智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20campus%20romance%20cover%2C%20young%20couple%20in%20school%20uniform%20under%20cherry%20blossoms%2C%20spring%20atmosphere%2C%20pink%20pastel%20tones%2C%20webtoon%20art%20style%2C%20romantic%20scene%2C%20Korean%20digital%20illustration&width=600&height=800&seq=manhwa-cover-09&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '校园', '青春'],
    description: '大学校园里的青涩恋爱故事。从图书馆的偶遇到校园祭的告白，从争吵到和好，记录了一对年轻恋人从相识到相爱的全过程。满满青春气息，甜到掉牙。',
    status: 'ongoing',
    updateDate: '2026-08-04',
    rating: 4.6,
    views: 1650000,
    chapters: [
      { id: 'c9-1', number: 1, title: '图书馆的邂逅', updateDate: '2026-02-14' },
      { id: 'c9-2', number: 2, title: '社团活动', updateDate: '2026-03-01' },
      { id: 'c9-3', number: 3, title: '第一次约会', updateDate: '2026-04-10' },
      { id: 'c9-4', number: 4, title: '误会', updateDate: '2026-05-20' },
      { id: 'c9-5', number: 5, title: '真心', updateDate: '2026-07-01' },
    ],
  },
  {
    id: '10',
    slug: 'rise-of-dragon',
    title: '龙之崛起',
    author: '朴俊秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20epic%20fantasy%20cover%2C%20dragon%20rising%20above%20ancient%20kingdom%2C%20mythical%20atmosphere%2C%20golden%20and%20crimson%20colors%2C%20grand%20scale%2C%20webtoon%20art%20style%2C%20legendary%20creature%2C%20Korean%20digital%20illustration&width=600&height=800&seq=manhwa-cover-10&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '龙', '史诗'],
    description: '在一个被龙族统治的世界里，人类少年意外与远古龙签订契约。从此他获得了无与伦比的力量，却也卷入了龙族内部的权力斗争。宏大的世界观，精美的战斗场面。',
    status: 'ongoing',
    updateDate: '2026-08-03',
    rating: 4.8,
    views: 2900000,
    chapters: [
      { id: 'c10-1', number: 1, title: '龙之契约', updateDate: '2025-10-01' },
      { id: 'c10-2', number: 2, title: '力量觉醒', updateDate: '2025-11-15' },
      { id: 'c10-3', number: 3, title: '龙族议会', updateDate: '2026-01-01' },
      { id: 'c10-4', number: 4, title: '暗流涌动', updateDate: '2026-03-01' },
      { id: 'c10-5', number: 5, title: '王位之争', updateDate: '2026-05-15' },
      { id: 'c10-6', number: 6, title: '最终决战', updateDate: '2026-07-10' },
    ],
  },
  {
    id: '11',
    slug: 'night-detective',
    title: '深夜侦探',
    author: '崔宇振',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20detective%20noir%20cover%2C%20detective%20in%20trench%20coat%20on%20rainy%20night%20street%2C%20neon%20reflections%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20webtoon%20art%2C%20Korean%20digital%20illustration&width=600&height=800&seq=manhwa-cover-11&orientation=portrait',
    category: 'thriller',
    tags: ['悬疑', '侦探', '都市'],
    description: '前刑警变身私家侦探，专接警方无法破解的悬案。每一个案件都扑朔迷离，每一个线索都环环相扣。在首尔深夜的街头，真相与谎言交织，谁是真正的凶手？',
    status: 'ongoing',
    updateDate: '2026-08-01',
    rating: 4.7,
    views: 1350000,
    chapters: [
      { id: 'c11-1', number: 1, title: '消失的证人', updateDate: '2026-03-01' },
      { id: 'c11-2', number: 2, title: '第二个死者', updateDate: '2026-04-10' },
      { id: 'c11-3', number: 3, title: '密室之谜', updateDate: '2026-05-20' },
      { id: 'c11-4', number: 4, title: '最后的线索', updateDate: '2026-07-01' },
    ],
  },
  {
    id: '12',
    slug: 'spring-blossom',
    title: '花开时节',
    author: '韩秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20healing%20drama%20cover%2C%20woman%20in%20flower%20field%20at%20sunset%2C%20warm%20golden%20light%2C%20peaceful%20atmosphere%2C%20soft%20illustration%20style%2C%20webtoon%20art%2C%20emotional%20depth%2C%20Korean%20digital%20art&width=600&height=800&seq=manhwa-cover-12&orientation=portrait',
    category: 'drama',
    tags: ['剧情', '治愈', '人生'],
    description: '花店老板与不同顾客之间的温暖故事。每一束花背后都有一段独特的人生，每一个顾客都带着各自的故事来到花店。温馨治愈，让人重新相信生活的美好。',
    status: 'completed',
    updateDate: '2026-05-30',
    rating: 4.8,
    views: 980000,
    chapters: [
      { id: 'c12-1', number: 1, title: '第一束花', updateDate: '2025-08-01' },
      { id: 'c12-2', number: 2, title: '求婚玫瑰', updateDate: '2025-09-15' },
      { id: 'c12-3', number: 3, title: '告别之花', updateDate: '2025-11-01' },
      { id: 'c12-4', number: 4, title: '重逢的百合', updateDate: '2026-01-10' },
      { id: 'c12-5', number: 5, title: '满园花开', updateDate: '2026-04-01' },
    ],
  },
  {
    id: '13',
    slug: 'bl-moonlight',
    title: '月光下的约定',
    author: '郑恩彩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20cover%2C%20two%20handsome%20men%20under%20moonlight%2C%20romantic%20night%20scene%2C%20soft%20blue%20and%20silver%20tones%2C%20elegant%20art%20style%2C%20webtoon%20illustration%2C%20Korean%20digital%20art&width=600&height=800&seq=manhwa-cover-13&orientation=portrait',
    category: 'bl',
    tags: ['耽美', '恋爱', '细腻'],
    description: '两个男人在月光下许下的约定，跨越了时间和世俗的偏见。精致的画风，细腻的情感描写，讲述了一段不被世俗理解却无比真挚的爱情故事。每一页都如同艺术品。',
    status: 'ongoing',
    updateDate: '2026-08-05',
    rating: 4.9,
    views: 3200000,
    chapters: [
      { id: 'c13-1', number: 1, title: '初遇', updateDate: '2026-01-01' },
      { id: 'c13-2', number: 2, title: '秘密', updateDate: '2026-02-10' },
      { id: 'c13-3', number: 3, title: '月光下的吻', updateDate: '2026-03-20' },
      { id: 'c13-4', number: 4, title: '暴风雨', updateDate: '2026-05-01' },
      { id: 'c13-5', number: 5, title: '永不分离', updateDate: '2026-06-15' },
      { id: 'c13-6', number: 6, title: '新的开始', updateDate: '2026-07-30' },
    ],
  },
  {
    id: '14',
    slug: 'martial-arts-king',
    title: '武林至尊',
    author: '朴俊秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20action%20cover%2C%20warrior%20in%20dynamic%20fighting%20pose%2C%20ancient%20Korean%20setting%2C%20intense%20battle%20scene%2C%20dramatic%20brush%20stroke%20style%2C%20webtoon%20art%2C%20Korean%20digital%20illustration&width=600&height=800&seq=manhwa-cover-14&orientation=portrait',
    category: 'action',
    tags: ['热血', '武侠', '格斗'],
    description: '被废武功的武林高手重生回到少年时代，凭借前世的记忆和经验，一步步重新踏上巅峰之路。酣畅淋漓的打斗场面，精彩的武学体系设定，热血沸腾的成长故事。',
    status: 'ongoing',
    updateDate: '2026-08-02',
    rating: 4.7,
    views: 2750000,
    chapters: [
      { id: 'c14-1', number: 1, title: '重生', updateDate: '2025-12-01' },
      { id: 'c14-2', number: 2, title: '入门试炼', updateDate: '2026-01-10' },
      { id: 'c14-3', number: 3, title: '初露锋芒', updateDate: '2026-02-20' },
      { id: 'c14-4', number: 4, title: '门派大比', updateDate: '2026-04-01' },
      { id: 'c14-5', number: 5, title: '江湖风云', updateDate: '2026-05-15' },
      { id: 'c14-6', number: 6, title: '至尊之战', updateDate: '2026-07-01' },
    ],
  },
  {
    id: '15',
    slug: 'cat-cafe-diary',
    title: '猫咪咖啡馆',
    author: '韩秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cute%20daily%20life%20cover%2C%20cozy%20cat%20cafe%20interior%20with%20adorable%20cats%2C%20warm%20lighting%2C%20pastel%20colors%2C%20healing%20atmosphere%2C%20webtoon%20art%20style%2C%20soft%20illustration%2C%20Korean%20digital%20art&width=600&height=800&seq=manhwa-cover-15&orientation=portrait',
    category: 'daily',
    tags: ['日常', '猫咪', '治愈'],
    description: '在首尔的一家猫咪咖啡馆里，每一只猫咪都有自己独特的性格和故事。咖啡香、阳光、还有毛茸茸的治愈时光，让你在忙碌的生活中感受片刻温暖与宁静。',
    status: 'ongoing',
    updateDate: '2026-07-28',
    rating: 4.5,
    views: 720000,
    chapters: [
      { id: 'c15-1', number: 1, title: '橘子猫小橘', updateDate: '2026-02-01' },
      { id: 'c15-2', number: 2, title: '高冷布偶', updateDate: '2026-03-15' },
      { id: 'c15-3', number: 3, title: '新来的小奶猫', updateDate: '2026-05-01' },
      { id: 'c15-4', number: 4, title: '猫咪的日常', updateDate: '2026-06-20' },
    ],
  },
  {
    id: '16',
    slug: 'reborn-queen',
    title: '重生之女王归来',
    author: '李恩珠',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20revenge%20cover%2C%20elegant%20powerful%20woman%20in%20luxurious%20setting%2C%20cold%20determined%20expression%2C%20dramatic%20lighting%2C%20webtoon%20art%20style%2C%20sophisticated%20atmosphere%2C%20Korean%20digital%20illustration&width=600&height=800&seq=manhwa-cover-16&orientation=portrait',
    category: 'drama',
    tags: ['剧情', '重生', '复仇'],
    description: '被最信任的人背叛杀害后，她重生回到了十年前。这一次，她不会再做任人宰割的羔羊。精心布局，步步为营，一场华丽的复仇大戏拉开帷幕。智商在线，反转不断。',
    status: 'ongoing',
    updateDate: '2026-08-04',
    rating: 4.8,
    views: 3500000,
    chapters: [
      { id: 'c16-1', number: 1, title: '死亡', updateDate: '2025-11-01' },
      { id: 'c16-2', number: 2, title: '回到十年前', updateDate: '2025-12-01' },
      { id: 'c16-3', number: 3, title: '第一步棋', updateDate: '2026-01-20' },
      { id: 'c16-4', number: 4, title: '暗流', updateDate: '2026-03-01' },
      { id: 'c16-5', number: 5, title: '收网', updateDate: '2026-05-01' },
      { id: 'c16-6', number: 6, title: '女王的加冕', updateDate: '2026-07-15' },
    ],
  },
];

export const heroComics = comics.filter((c) => ['she-is-young', 'sword-of-destiny', 'secretary-kim'].includes(c.slug));

export const popularComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 8);

export const latestComics = [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 8);